import { Button, typography } from '@insurancemenu/imenu-components-lib';
import styled from 'styled-components';

export const DropdownButtonStyled = styled(Button)`
  ${typography.bold[16]}
`;
